import React from "react";
import { useTranslation } from "react-i18next";

import { sendTestEmail } from "@admin/api/config";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export const usePostEmailConfig = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const { t } = useTranslation(["pages"]);

    const onMutate = () => {
        setIsLoading(true);
        void sendTestEmail()
            .then(() => showSuccessToast(t("pages:adminEmailPage.toast.testEmailSentSuccess")))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
